import { Box, Skeleton, Stack } from "@mui/material";

const RowSkeleton = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        py: 1.5,
        borderBottom: "1px solid #eee",
      }}
    >
      {/* Metric Name */}
      <Skeleton variant="text" width={80} height={24} />

      {/* Actual / Target */}
      <Skeleton variant="text" width={160} height={24} />

      {/* Gap */}
      <Skeleton variant="text" width={100} height={24} />

      {/* Attainment badge */}
      <Skeleton
        variant="rounded"
        width={60}
        height={28}
        sx={{ borderRadius: "8px" }}
      />
    </Stack>
  );
};

const RecentSkeleton = () => {
  return (
    <Box sx={{ py: 2 }}>
      {/* Quarter dropdown skeleton */}
      <Skeleton
        variant="rounded"
        width={220}
        height={40}
        sx={{ borderRadius: "10px", mb: 2 }}
      />

      {/* Section title */}
      <Skeleton variant="text" width={150} height={30} sx={{ mb: 2 }} />

      {/* Table header */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          py: 1,
          backgroundColor: "#f5f5f5",
          px: 1,
          mb: 1,
        }}
      >
        <Skeleton variant="text" width={80} />
        <Skeleton variant="text" width={160} />
        <Skeleton variant="text" width={100} />
        <Skeleton variant="text" width={80} />
      </Stack>

      {/* 8 rows */}
      {Array.from({ length: 10 }).map((_, index) => {
        const opacity = 1 - index * 0.08;

        return (
          <Box key={index} sx={{ opacity }}>
            <RowSkeleton />
          </Box>
        );
      })}

      {/* Last 2 Weeks section skeleton */}
    </Box>
  );
};

export default RecentSkeleton;
